export function convertTonnage(data) {
  let tonnage = Math.max(0, data.tonnage).toFixed(2);
  let remainingTonnage = Math.max(
    0,
    data.tonnage - data.receivedTonnage
  ).toFixed(2);

  if (data.unitType === "SEFER") {
    // Function to convert tonnage to SEFER
    const convertToSefer = (ton) => {
      if (ton < 20) return 0;
      if (ton >= 20 && ton <= 32) return 1;
      return Math.ceil(ton / 26);
    };

    tonnage = convertToSefer(tonnage);
    remainingTonnage = convertToSefer(parseFloat(remainingTonnage));
  }

  return `${tonnage} / ${remainingTonnage} ${data.unitType || "TON"}`;
}